import "@hotwired/turbo-rails"
import "./controllers"

Turbo.config.forms.mode = "optin"

